import FaLinkedin from "../SVG/Fontawesome/FaLinkedin";
import FaYoutube from "../SVG/Fontawesome/FaYoutube";
import FaFacebook from "../SVG/Fontawesome/FaFacebook";
import FaTelegram from "../SVG/Fontawesome/FaTelegram";
import FaInstagram from "../SVG/Fontawesome/FaInstagram";
import LinkWrapper from "../LinkWrapper";

const FooterSocials = () => {
  return (
    <section className="flex flex-wrap items-center justify-center pt-4 pb-4 gap-8 text-xl mb-0">
      <a id="linkedin" href="https://www.linkedin.com/company/weareallendigital/" target={"_blank"} className="rounded-full border-2 border-body text-accent  w-10 h-10 flex justify-center items-center" rel="noreferrer noopener">
        <FaLinkedin />
      </a>
      <a id="youtube" href="https://www.youtube.com/@ALLENOnlinePrograms" target={"_blank"} className="rounded-full border-2 border-body text-accent  w-10 h-10 flex justify-center items-center" rel="noreferrer noopener">
        <FaYoutube />
      </a>
      <a id="facebook" href="https://www.facebook.com/allenonlineprograms" target={"_blank"} className="rounded-full border-2 border-body text-accent  w-10 h-10 flex justify-center items-center" rel="noreferrer noopener">
        <FaFacebook />
      </a>
      <LinkWrapper id="telegram" href="https://t.me/allencareerinstitute_official" className="rounded-full border-2 border-body text-accent  w-10 h-10 flex justify-center items-center" rel="noreferrer">
        <FaTelegram />
      </LinkWrapper>
      <LinkWrapper id="instagram" href="https://www.instagram.com/allenonlineofficial/" className="rounded-full border-2 border-body text-accent  w-10 h-10 flex justify-center items-center" rel="noreferrer">
        <FaInstagram />
      </LinkWrapper>
    </section>
  );
}

export default FooterSocials;
